module.exports = __webpack_public_path__ + "media/packs/assets/images/butlers/butlers-72f203a835c12354376bc47a854d3a1e.png";